import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query';

import { getPdpInfiniteRecommendItemList } from '../graphql/inifinite_recommend.2';

const QUERY_KEY = 'getPDPInfiniteRecommendList';

const fetchPdpInfiniteRecommendList = async (...params: Parameters<typeof getPdpInfiniteRecommendItemList>) => {
  const {
    data: { pdp_infinite_recommend_group },
  } = await getPdpInfiniteRecommendItemList(...params);
  return pdp_infinite_recommend_group;
};

type PdpInfiniteRecommendList = Awaited<ReturnType<typeof fetchPdpInfiniteRecommendList>>;

interface InfiniteQueryConfig
  extends Omit<
    UseInfiniteQueryOptions<
      PdpInfiniteRecommendList,
      unknown,
      PdpInfiniteRecommendList,
      PdpInfiniteRecommendList,
      string[]
    >,
    'queryKey' | 'queryFn'
  > {
  catalog_product_id: string;
  end_cursor?: string | null;
}

export const usePdpInfiniteRecommendList = ({ catalog_product_id, end_cursor, ...rest }: InfiniteQueryConfig) => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEY, catalog_product_id, ...(end_cursor ? [end_cursor] : [])],
    queryFn: ({ pageParam = null }) =>
      fetchPdpInfiniteRecommendList(
        {
          catalog_product_id,
          end_cursor: pageParam,
        },
        { show_alert: false },
      ),
    getNextPageParam: (data) => (data?.has_next ? data.end_cursor : null),
    ...rest,
  });
};
